const data = {
  id: "boards_oversight",
  title: "Boards, Directors, & School Boards",
  intro: "They control hundreds of millions in public funds, set policy across Madison County, and never appear on a ballot. Who appointed them, what budgets they control, how many students they're responsible for, and who they actually serve — documented.",
  tabs: [
    {
      id: "appointed_boards",
      label: "Appointed Boards",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "directors_executives",
      label: "Directors & Executives",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "school_boards_staff",
      label: "School Boards & Staff",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};

export default data;
